// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"styles_suggestion__2JmpF","disabled":"styles_disabled__2fkkO","inputContainer":"styles_inputContainer__3Ppyc"};